/**
 * Appends query params to a path; `HttpClient` only forwards params for GET requests.
 */
export function withQueryParams(path: string, params?: object) {
  if (!params) return path

  const query = new URLSearchParams()

  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) continue
    query.append(key, String(value))
  }

  const queryString = query.toString()

  return queryString ? `${path}?${queryString}` : path
}
